import { IUploadImage } from '@Domains/UploadImage';
import {
  CompleteSectionFormValues,
  IntroductionFormValues,
  OtherExplanationsFormValues,
  RemarkFormValues,
} from '@Utils/Types/FormValuesTypes';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';

export interface INatureOfBusinessFormValues {
  id?: number;
  startOperatingYear?: number;
  introduction?: IntroductionFormValues;
  corporateInformation?: CorporateInformationFormValues;
  productInformation?: ProductInformationFormValues;
  marketingIndustry?: MarketingIndustryFormValues;
  incomeStructure?: IIncomeStructureFormValues;
  otherDescriptions?: OtherExplanationsFormValues[];
  remark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
}

export type CorporateInformationFormValues = {
  id?: number;
  introduction?: IntroductionFormValues;
  thai: CorporateInformationThaiFormValues;
  english: CorporateInformationEnglishFormValues;
  remark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
};

export type CorporateInformationThaiFormValues = {
  companyTh: string;
  symbolTh: string;
  addressTh: string;
  provinceTh: string;
  zipcodeTh: string;
  businessTypeTh: string;
  faxTh: string;
  telephoneTh: string;
  registeredNumberTh: string;
  websiteTh: string;
  emailTh: string;
};

export type CorporateInformationEnglishFormValues = {
  companyEn: string;
  symbolEn: string;
  addressEn: string;
  provinceEn: string;
  zipcodeEn: string;
  businessTypeEn: string;
  faxEn: string;
  telephoneEn: string;
  registeredNumberEn: string;
  websiteEn: string;
  emailEn: string;
};

export type BusinessGroupInfoFormValues = {
  id?: number;
  nameTh: string;
  nameEn: string;
  descriptionTh: string;
  descriptionEn: string;
  sequence: number;
  assets?: Array<IUploadImage>;
};

export enum BusinessTypes {
  MANUFACTURING_SERVICE = 'MANUFACTURING',
  FINANCIAL_INSTITUTIONS = 'FINANCIAL_INSTITUTION',
}

export type ProductInformationFormValues = {
  id?: number;
  introduction?: IntroductionFormValues;
  businessType: BusinessTypes | null;
  businessGroupIntroduction?: IntroductionFormValues;
  businessGroupRemark?: RemarkFormValues;
  businessGroupInfos: Array<BusinessGroupInfoFormValues>;
  remark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
};

export enum MarketingIndustryTypes {
  OVERALL = 'BUSINESS_OVERVIEW',
  SPECIFIC = 'PRODUCT_SERVICE_BASED',
}

export type MarketingIndustryFormValues = {
  id?: number;
  type: MarketingIndustryTypes | null;
  introduction?: IntroductionFormValues;
  remark?: RemarkFormValues;
  marketingPolicyIntroduction?: IntroductionFormValues;
  marketingPolicyRemark?: RemarkFormValues;
  marketingPolicy: Array<MarketingPolicyFormValues>;
  completedSection?: CompleteSectionFormValues;
};

export type MarketingPolicyFormValues = {
  id?: number;
  productNameTh?: string;
  descriptionTh: string;
  industryCompetitionDescTh: string;
  productNameEn?: string;
  descriptionEn: string;
  industryCompetitionDescEn: string;
  salesRatioIntroduction?: IntroductionFormValues;
  salesRatioRemark?: RemarkFormValues;
  domesticExportSalesRatio?: Array<DomesticExportSalesRatioFormValues>;
  assets?: Array<IUploadImage>;
};
export type DomesticExportSalesRatioFormValues = {
  id?: number;
  sequence: number;
  countryNameTh: string;
  countryNameEn: string;
  countryCodeTh: string;
  countryCodeEn: string;
  ratio: number;
};

export interface IIncomeCategoryFormValues {
  id?: number;
  nameTh: string;
  nameEn: string;
  subGroup?: INCOME_SUBGROUP_CATEGORY;
  infoCategoryMasterDataId?: number;
  sequence?: number;
}

export interface IIncomeItemFormValues {
  id?: number;
  incomeCategory?: IIncomeCategoryFormValues;
  asOfYear?: string;
  asOfYesteryear?: string;
  asOfYearBeforeYesteryear?: string;
  sequence?: number;
}

export interface IIncomeStructureFormValues {
  id?: number;
  introduction?: IntroductionFormValues;
  productIncomeItems: Record<string, IIncomeItemFormValues>;
  productIncomePercentages: Record<string, IIncomeItemFormValues>;
  exportIncomeItems: Record<string, IIncomeItemFormValues>;
  exportIncomePercentages: Record<string, IIncomeItemFormValues>;
  otherIncomeItems: Record<string, IIncomeItemFormValues>;
  remark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
  assets?: Array<IUploadImage>;
}
